import { WarehouseInventoryProductsService } from '../../api/services/WarehouseInventoryProductsService';
import { InventoryFilterState } from '../../types/inventory';

export type WarehouseInventoryListScope = {
  excludeCancelledAvailability?: boolean;
  warehousePlacementOnly?: boolean;
  assignedPlacementOnly?: boolean;
};

export type WarehouseInventoryFindAllArgs = Parameters<
  typeof WarehouseInventoryProductsService.warehouseInventoryProductsControllerFindAll
>;

/** Maps legacy single `status` filter to API placement status (warehouse query page). */
export function warehouseQueryPlacementStatus(status: string | undefined): string | undefined {
  if (status === 'UNASSIGNED' || status === 'IN_TRANSIT') {
    return status;
  }
  return undefined;
}

/** Maps warehouse KPI / filter to availability status (e.g. Bloqueadas → RESERVED). */
export function warehouseQueryAvailabilityStatus(status: string | undefined): string | undefined {
  if (status === 'RESERVED') {
    return 'RESERVED';
  }
  return undefined;
}

function resolveLocationId(locationId: string | undefined): number | undefined {
  if (locationId == null || locationId === '' || locationId === '0') {
    return undefined;
  }
  return Number(locationId);
}

function resolveCategoryName(categoryName: string | undefined): string | undefined {
  if (categoryName == null || categoryName === '' || categoryName === 'Todos') {
    return undefined;
  }
  return categoryName;
}

export function buildWarehouseInventoryFindAllArgs(options: {
  page: number;
  limit: number;
  filters: InventoryFilterState;
  placementStatus?: string;
  availabilityStatus?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  scope?: WarehouseInventoryListScope;
  includeNumericFilters?: boolean;
}): WarehouseInventoryFindAllArgs {
  const {
    page,
    limit,
    filters,
    placementStatus,
    availabilityStatus,
    sortBy,
    sortOrder,
    scope = {},
    includeNumericFilters = false,
  } = options;

  return [
    page,
    limit,
    undefined, // productCode
    placementStatus,
    availabilityStatus,
    resolveLocationId(filters.locationId),
    undefined, // transferredToBranch
    undefined, // productCodeUnique
    undefined, // productName
    filters.searchTerm || undefined,
    resolveCategoryName(filters.categoryName),
    filters.createdAtStart || undefined,
    filters.createdAtEnd || undefined,
    filters.recordCode || undefined,
    filters.searchTag || undefined,
    filters.materialId ? Number(filters.materialId) : undefined,
    filters.diameterSize || undefined,
    filters.color || undefined,
    filters.workshopCode || undefined,
    includeNumericFilters ? filters.weightGramsMin : undefined,
    includeNumericFilters ? filters.weightGramsMax : undefined,
    includeNumericFilters ? filters.salePriceMin : undefined,
    includeNumericFilters ? filters.salePriceMax : undefined,
    includeNumericFilters ? filters.salePricePerGramMin : undefined,
    includeNumericFilters ? filters.salePricePerGramMax : undefined,
    sortBy,
    sortOrder != null ? (sortOrder === 'asc' ? 'ASC' : 'DESC') : undefined,
    scope.excludeCancelledAvailability,
    scope.warehousePlacementOnly,
    scope.assignedPlacementOnly,
    filters.supplierId ? Number(filters.supplierId) : undefined,
  ];
}
